import { createSelector } from "reselect"

const getAccount = state => state.global.selected.account

export const getPortfolioUrlGetter = createSelector(
  [getAccount],
  (account) => id => `/${account}/p/${id}`,
)

export const getResearchTopicUrlGetter = createSelector(
  [getAccount],
  (account) => id => `/${account}/t/${id}`,
)

export const getWatchlistUrlGetter = createSelector(
  [getAccount],
  (account) => id => `/${account}/watchlist/${id}`,
)

export const getSwapUrlGetter = createSelector(
  [getAccount],
  (account) => id => `/${account}/composite/basket/${id}`,

)

export const getPortfolioExperimentUrlGetter = createSelector(
  [getAccount],
  (account) => portfolioId => `/${account}/p/${portfolioId}/rebalance/experiments`,
)

export const getResearchTopicExperimentUrlGetter = createSelector(
  [getAccount],
  (account) => topicId => `/${account}/t/${topicId}/experiments`,
)

export const getDatacloudUrlGetter = createSelector(
  [getAccount],
  (account) => tab => `/${account}/home/data-cloud/${tab}`,
)

// [TODO] can this be done better with new router
export const getPath = () => {
  const fullPath = window.location.pathname
  return fullPath.substr(fullPath.lastIndexOf("/") + 1)
}

// [TODO] can this be done better with new router
export const getRoute = () => {
  const currentUrl = window.location.pathname
  return currentUrl.substr(0, currentUrl.lastIndexOf("/") + 1)
}
